import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap items-center md:space-x-4 md:flex-none"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "w-full mt-2 md:w-fit" }

import { computed, ref } from "vue";
import { storeToRefs } from "pinia";

import ExternalLink from "../ExternalLink.vue";

import { getUsersHighestRole } from "@/utils/roles";
import { useUserStore } from "@/store";
import api from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionBanner',
  async setup(__props) {

let __temp: any, __restore: any

const expireStatuses = ["expired", "cancelled"];

const { user } = storeToRefs(useUserStore());
let subscription = getUsersHighestRole(user.value.roles).display_name;

if (subscription === "Advanced Facilitator Trainee") {
  subscription = "Certified Facilitator";
}

if (subscription.toLowerCase() === "level 04a trainee" || subscription.toLowerCase() === "trainee trainer") {
    subscription = "Advanced Facilitator";
}

const url = `${process.env.VUE_APP_WEBSITE_URL}/courses/register-for-a-training-course/book/subscription/`;
const isExpiringSoon = new Date(user.value.subscription_end) < new Date(new Date().setDate(new Date().getDate() + 30));
const isExpired = expireStatuses.includes(user.value.subscription_status);

const theme = computed(() => {
  if (isExpired || user.value.subscription_status === "pending") {
    return "bg-alert-danger border-alert-danger-600";
  }

  if (isExpiringSoon && !isExpired) {
    return "bg-alert-warning border-alert-warning-600";
  }

  return "bg-alert-success border-alert-success-600";
});

const canSeeSubscriptionBanner = ref(false);
canSeeSubscriptionBanner.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.actions.getSubscriptionBanner())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.showSubscriptionBanner;

return (_ctx: any,_cache: any) => {
  return (canSeeSubscriptionBanner.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_unref(theme), 'flex flex-wrap md:flex- items-center justify-between p-4 border rounded text-alert-secondary-600'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("current-membership")) + " - ", 1),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(subscription) !== "Parent / Carer" ? _unref(subscription) : "Parent/Carer (Free membership)"), 1),
            (_unref(isExpired))
              ? (_openBlock(), _createElementBlock("strong", _hoisted_2, "(" + _toDisplayString(_ctx.$t("expired")) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_unref(subscription) !== 'Parent / Carer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_unref(isExpired) && _unref(user).subscription_end)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("subscription-expires", [new Date(_unref(user).subscription_end).toDateString()])), 1))
                : _createCommentVNode("", true),
              (_unref(isExpired))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("subscription-expired", [new Date(_unref(user).subscription_end).toDateString()])), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                isExpiringSoon
                  ? (_openBlock(), _createBlock(ExternalLink, {
                      key: 0,
                      type: "button",
                      label: _ctx.$t('update-subscription'),
                      href: url
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})